import React from "react";
import "../../styles/categories.css";
import enroll from "../../assets/enroll.jpeg";
import lecture from "../../assets/lecture.jpeg";
import support from "../../assets/support.jpeg";
import skills from "../../assets/skills.jpeg";
import graduate from "../../assets/graduate.jpeg";




const HowItWorks = () => {
  const stepsData = [
    {
      id: 1,
      title: "Enroll in the degree program",
      desc: "through Madhi Academy.",
      img:enroll,
    },
    {
      id: 2,
      title: "Attend online lectures",
      desc: "from university faculty.",
      img: lecture
    },
    {
      id: 3,
      title: "Get tuition support",
      desc: "from Madhi Academy for difficult subjects.",
      img:support,
    },
    {
      id: 4,
      title: "Complete add-on job skills",
      desc: "training alongside degree studies.",
      img:skills
    },
    {
      id: 5,
      title: "Graduate with both degree + professional",
      desc: "skills.",
      img:graduate
    }
  ];

  return (
    <section className="how-it-works-section container">
      {/* Section Title */}
      <h2 className="hiw-section-title text-center">
        How It Works
      </h2>

      <div className="hiw-wrapper">
        {stepsData.map((item) => (
          <div key={item.id} className="hiw-item">
            {/* Image Container */}
            <div className="hiw-img-box">
              <img src={item.img} alt={item.title} className="hiw-img" />
            </div>
            
            {/* Text Content */}
            <h5 className="hiw-title">{item.title}</h5>
            <p className="hiw-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;